var map = {
	"./banner.svg": 420,
	"./contact.svg": 421,
	"./crud.svg": 422,
	"./features.svg": 423,
	"./gallery.svg": 424,
	"./gen.svg": 425,
	"./icons.svg": 426,
	"./navigation.svg": 427,
	"./partners.svg": 428,
	"./paymentMethods.svg": 429,
	"./search.svg": 430,
	"./social.svg": 431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 419;